/**
 * Created by jjing on 6/1/2017.
 */
import React, {Component} from 'react';
import {Button, Alert} from 'react-bootstrap';
import request from 'superagent';
import ToolBar from "../../commons/ToolBar";
import PolicyTable from './PolicyTable';
import ConfirmModal from './component/ConfirmModal';
import PolicyConfigView from "./PolicyConfigRViewAntd";
import PolicyVerifyView from "./PolicyVerifyViewRAntd";
import PolicyBroadcast from "./PolicyBroadcast";
import Constants, {Lock_Status, Permissions} from '../../commons/Constants';
import {openNotification, NotificationType, permissionCheck} from "../../commons/CommonUtils";
import SvgIcon from "../../commons/SvgIcon";


class PolicyListView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            policyList: [],
            products: [],
            selectedPolicy: null,
            openVerify: false,
            openBroadcast: false,
            tenants: [],
            containerHeight: 2000
        };
    }

    componentDidMount() {
        this.initAllData();
    }

    initAllData = () => {
        this.setState({status: Constants.STATUS.trying});
        this.checkPolicyLock();
        this.getProducts()
            .then(this.getTenants)
            .then(this.getPolicies)
            .then(this.fitTableHeight)
            .then(() => this.setState({status: Constants.STATUS.done}))
            .catch(err => {
                openNotification("Failed to get upgrade policies.", NotificationType.error);
                this.setState({status: Constants.STATUS.error});
                console.error("Failed to get upgrade policies.", err);
            });
    }

    getProducts = () => {
        return request.get('/api/pec1sumiddleware')
            .query({urlPath: '/products'})
            .then(res => {
                this.setState({products: res.body});
            });
    }

    getTenants = () => {
        return request.get('/api/tenant-manager')
            .then(res => {
                this.setState({tenants: res.body.tenants});
            });
    }

    getPolicies = () => {
        this.setState({policyList: []});
        return request.get('/api/pec1sumiddleware')
            .query({urlPath: '/policies'})
            .then(res => {
                this.setState({policyList: res.body});
            })
    }

    fitTableHeight = () => {
        let adjust = 110;
        const lockStatus = this.state.lockStatus;
        if (lockStatus === Lock_Status.lock_lock || lockStatus === Lock_Status.lock_free) {
            adjust += document.getElementById('alert-container').clientHeight + 20;
        }
        const height = document.getElementById('container').clientHeight - adjust;
        this.setState({containerHeight: height});
        return true;
    }

    refreshTable = () => {
        this.setState({status: Constants.STATUS.trying});
        this.checkPolicyLock();
        this.getPolicies()
            .then(this.fitTableHeight)
            .then(() => this.setState({status: Constants.STATUS.done}))
            .catch(err => {
                openNotification("Failed to get upgrade policies.", NotificationType.error);
                this.setState({status: Constants.STATUS.error});
                console.error("Failed to get upgrade policies.", err);
            });
    }

    checkPolicyLock = (callback) => {
        request.get('/api/policy/isOwnLock')
            .end((err, res) => {
                if (err) {
                    console.log('Policy action is locked');
                    this.setState({
                        lockStatus: Lock_Status.lock_lock,
                        message: "Another user is changing the policy, please wait."
                    });
                } else {
                    if (res.body) {
                        console.log('Policy action is free');
                        this.setState({
                            lockStatus: Lock_Status.lock_free,
                            message: "You have changed policies. Click Commit to save and execute these changes. " +
                            "If you do not perform any operations in 10 minutes or you log out before committing, " +
                            "the system will discard your changes."
                        });
                    } else {
                        console.log('Policy action is free for empty lock');
                        this.setState({lockStatus: Lock_Status.lock_Empty});
                    }
                    if (callback)
                        callback();
                }
            });
    }

    onClickDelete = (policyids, onDelete) => {
        this.setState({
            confirmTitle: "Confirm Delete",
            confirmBody: "Do you want to delete this policy?",
            confirmIsDelete: true
        });
        const totalCount = policyids.length;
        this.confirmModal.setCallBack(() => {
            let finishCount = 0, fineCount = 0;
            policyids.forEach((policyid) =>
                request.del('/api/pec1sumiddleware')
                    .query({urlPath: '/policy/' + policyid})
                    .end((err, res) => {
                        finishCount++;
                        if (!err) {
                            fineCount++;
                        } else {
                            openNotification("Fail to delete [" + policyid + "]. Cause by: "
                                + err.message, NotificationType.error);
                        }
                        if (finishCount === totalCount) {
                            openNotification("Succeed to delete " + fineCount + " policies. "
                                + (finishCount - fineCount > 0 ? " policies failed to delete. Please check." : ""),
                                (finishCount - fineCount > 0 ? "warning" : "success"));
                            this.refreshTable();
                        }
                    }));
            this.confirmModal.close();
            if (onDelete)
                onDelete();
        })

        this.confirmModal.open();
    }

    onSwapPolicy = (fromid, toid) => {
        this.setState({
            confirmTitle: "Confirm exchange policy",
            confirmBody: "Do you want to change the order of this policy?",
            confirmIsDelete: false
        });

        this.confirmModal.setCallBack(() => this.checkPolicyLock(() => {
            request("PATCH", '/api/pec1sumiddleware')
                .query({urlPath: '/policies/swap/' + fromid + '/' + toid})
                .end((err, res) => {
                    this.confirmModal.close();
                    if (!err) {
                        openNotification("Succeed to exchange the order.", NotificationType.success);
                        this.refreshTable();
                    }
                    else {
                        openNotification("Fail to exchange the order. Cause by: " + err.message, NotificationType.error);
                    }
                });
        }));
        this.confirmModal.open();
    }

    onCommit = () => {
        this.setState({
            confirmTitle: "Confirm commit",
            confirmBody: "Do you want to commit all of change of policies?",
            confirmIsDelete: false
        });
        this.confirmModal.setCallBack(() => {
            request("POST", '/api/policy/commit')
                .query({urlPath: '/policies'})
                .end((err, res) => {
                    this.confirmModal.close();
                    if (!err) {
                        openNotification("Succeed to commit all change of policy.", NotificationType.success);
                        this.refreshTable();
                    } else {
                        openNotification("Fail to commit. Cause by: " + err.message, NotificationType.error);
                    }
                });
        });
        this.confirmModal.open();
    }

    onRevertChange = () => {
        this.setState({
            confirmTitle: "Confirm revert",
            confirmBody: "Do you want to revert the un-committed change?",
            confirmIsDelete: false
        });
        this.confirmModal.setCallBack(() => {
            request("PUT", '/api/policy/revert')
                .end((err, res) => {
                    this.confirmModal.close();
                    if (!err) {
                        openNotification("Succeed to revert all un-committed change of policy.", NotificationType.success);
                        this.refreshTable();
                    } else {
                        openNotification("Fail to revert. Cause by: " + err.message, NotificationType.error);
                    }
                });
        });
        this.confirmModal.open();
    }

    _close = () => {
        this.setState({selectedPolicy: null, openVerify: false, openBroadcast: false});
    }

    openConfigPanel = (policyId) => {
        this.setState({selectedPolicy: policyId, openVerify: false, openBroadcast: false});
    }

    createCustomToolBar = (props) => {
        const { selectedPolicy, openVerify, lockStatus, openBroadcast } = this.state;

        const isHideAdd = !permissionCheck([Permissions.SoftwareUpgrade.ADD])
            || lockStatus === Lock_Status.lock_lock
            || lockStatus === Lock_Status.lock_free;
        const showSlide = selectedPolicy !== null || openVerify || openBroadcast;
        return (
            <div>
                <div className='buttonFiled' style={{ display: !showSlide ? 'block' : 'none'}}>
                    <ToolBar onAdd={() => this.openConfigPanel()} isHideAdd={isHideAdd}
                             onFresh={this.refreshTable}
                             extension={
                             <div style={{display: 'inline-block'}}>
                                <Button onClick={() => this.setState({openVerify: true, selectedPolicy: null, openBroadcast: false})}
                                    type="button" title="Verify">
                                <SvgIcon name="check_circle_outline" style={{ color: "#00ADEE" }} />Verify
                                </Button>
                                <Button onClick={() => this.setState({openVerify: false, selectedPolicy: null, openBroadcast: true})}
                                    type="button" title="Broadcast">
                                <SvgIcon name="volume_max" style={{ color: "#00ADEE" }} />Broadcast
                                </Button>
                             </div>
                             }/>
                </div>
                <div className='searchFiled' style={{width: showSlide ? '100%': ''}}>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    render = () => {
        const {
            policyList, products, selectedPolicy, openVerify, containerHeight,
            confirmTitle, confirmBody, status, lockStatus, message, openBroadcast
            } = this.state;

        const isAlert = lockStatus === Lock_Status.lock_lock || lockStatus === Lock_Status.lock_free;
        const showSlide = selectedPolicy !== null || openVerify || openBroadcast;

        return (
            <div className="page-container">
                <div id="container" className={`${showSlide ? 'col-md-5': 'col-md-12'} list`}>
                    <h2 className="page-title">Software Upgrade</h2>
                    {(isAlert && !showSlide) &&
                    <div id="alert-container">
                        <Alert bsStyle="info">
                            {message}
                            {lockStatus === Lock_Status.lock_free &&
                            <div className="toolBar">
                                <Button title="Commit" className="btn-commit" type="button"
                                        onClick={() => this.onCommit()}>Commit
                                </Button>
                                <a onClick={this.onRevertChange}>Revert</a>
                            </div>
                            }
                        </Alert>
                    </div>}

                    <PolicyTable ref={(table) => this.table = table }
                                 height={containerHeight} selectedPolicy={selectedPolicy}
                                 tenants={this.state.tenants} policyList={policyList} products={products}
                                 openConfigPanel={this.openConfigPanel} showSlide={showSlide}
                                 onSwapPolicy={this.onSwapPolicy} lockStatus={lockStatus}
                                 loading={status === Constants.STATUS.trying}
                                 toolBar={this.createCustomToolBar}/>
                </div>

                { showSlide && (
                    <div id="detailContainer" className='col-md-7 detailInfo'>
                        { selectedPolicy !== null && (
                            <PolicyConfigView policyId={selectedPolicy} products={products}
                                              tenants={this.state.tenants} lockStatus={lockStatus}
                                              deleteFun={this.onClickDelete}
                                              onClose={() => {this._close();this.refreshTable();}}/>
                        )}
                        { openVerify && (
                            <PolicyVerifyView products={products} tenants={this.state.tenants}
                                              onClose={() => {this._close();this.refreshTable();}}/>
                        )}
                        { openBroadcast && (
                            <PolicyBroadcast products={products}
                                             onClose={() => {this._close();this.refreshTable();}}/>
                        )}
                    </div>
                )}
                <ConfirmModal ref={(confirm) => { this.confirmModal = confirm }}
                              title={confirmTitle} body={confirmBody}
                              isConfirm="true" isDelete={this.state.confirmIsDelete}/>
            </div>);
    }

}

export default PolicyListView;


// WEBPACK FOOTER //
// ./src/modules/policy/PolicyListView.js